export default "__VITE_ASSET__D4Mt2IU5__"